import Axios from "./axios";

const resource = "business-sliders";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}